// Attribution tracking for the Request Access form — e.g. a link shared as
// buildahead.com?source=reddit-constructionmanagers. Captured once when the visitor
// lands on the page and persisted in sessionStorage so it survives navigation within the
// same visit (the query param itself won't still be in the URL after the visitor clicks
// around the site).

const SOURCE_KEY = 'buildahead_source';

export function captureSource(): void {
  try {
    const params = new URLSearchParams(window.location.search);
    const source = params.get('source');
    if (source) sessionStorage.setItem(SOURCE_KEY, source);
  } catch {
    /* private browsing / storage blocked — source just won't be tracked */
  }
}

export function getSource(): string {
  try {
    return sessionStorage.getItem(SOURCE_KEY) || 'direct';
  } catch {
    return 'direct';
  }
}
